import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import logo from "../../../assets/img/DS.svg";

const BASE = "/stdcounciladmin/adminhome";

export default function AdminSidebar() {
  const location = useLocation();

  const [openMenu, setOpenMenu] = useState({
    intro: false,
    org: false,
    content: false,
    data: false,
    group: false,
    site: false,
  });

  const introMap = {
    intro: "총학생회",
    scitech: "과학기술대학",
    global: "글로벌융합대학",
    future: "미래인재대학",
    pharm: "약학대학",
    artdesign: "아트앤디자인대학",
    club: "동아리연합회",
  };

  useEffect(() => {
    const path = location.pathname;

    setOpenMenu({
      intro: path.includes("/intro"),
      org: path.includes("/organization"),
      content: path.includes("/contents"),
      data: path.includes("/data"),
      group: path.includes("/group"),
      site: path.includes("/site"),
    });
  }, [location.pathname]);

  const toggleMenu = (key) => {
    setOpenMenu((prev) =>
      Object.keys(prev).reduce((acc, k) => {
        acc[k] = k === key ? !prev[k] : false;
        return acc;
      }, {})
    );
  };

  const isActive = (path) => location.pathname.includes(path);

  return (
    <aside className="sidebar">
      <div className="sidebar-brand">
        <div className="brand-left">
          <img
            src={logo}
            alt="덕성여대 총학생회 로고"
            className="sidebar-logo"
          />

          <div className="sidebar-title">
            <span>덕성여자대학교 총학생회</span>
            <span>홈페이지 관리</span>
          </div>
        </div>
      </div>

      <nav className="sidebar-nav">
        <div
          className={`sidebar-box clickable ${openMenu.intro ? "is-open" : ""}`}
          onClick={() => toggleMenu("intro")}
          aria-expanded={openMenu.intro}
        >
          <span>소개 관리</span>
          <span className={`arrow ${openMenu.intro ? "is-open" : ""}`} />
        </div>

        {openMenu.intro && (
          <div className="submenu">
            {Object.keys(introMap).map((key) => (
              <NavLink
                key={key}
                to={`${BASE}/intro/${key}/current/student`}
                className="submenu-item"
              >
                <span
                  className={`dot ${
                    isActive(`/intro/${key}`) ? "is-selected" : ""
                  }`}
                />
                <span className="submenu-text">{introMap[key]}</span>
              </NavLink>
            ))}
          </div>
        )}

        <div
          className={`sidebar-box clickable ${openMenu.org ? "is-open" : ""}`}
          onClick={() => toggleMenu("org")}
          aria-expanded={openMenu.org}
        >
          <span>조직도 관리</span>
          <span className={`arrow ${openMenu.org ? "is-open" : ""}`} />
        </div>

        {openMenu.org && (
          <div className="submenu">
            <NavLink to={`${BASE}/organization/exec`} className="submenu-item">
              <span
                className={`dot ${
                  isActive("/organization/exec") ? "is-selected" : ""
                }`}
              />
              <span className="submenu-text">회장단</span>
            </NavLink>

            <NavLink to={`${BASE}/organization/office`} className="submenu-item">
              <span
                className={`dot ${
                  isActive("/organization/office") ? "is-selected" : ""
                }`}
              />
              <span className="submenu-text">중앙집행국</span>
            </NavLink>
          </div>
        )}

        <div
          className={`sidebar-box clickable ${
            openMenu.content ? "is-open" : ""
          }`}
          onClick={() => toggleMenu("content")}
          aria-expanded={openMenu.content}
        >
          <span>콘텐츠 관리</span>
          <span className={`arrow ${openMenu.content ? "is-open" : ""}`} />
        </div>

        {openMenu.content && (
          <div className="submenu">
            <NavLink to={`${BASE}/contents/notice`} className="submenu-item">
              <span
                className={`dot ${
                  isActive("/contents/notice") ? "is-selected" : ""
                }`}
              />
              <span className="submenu-text">공지사항 관리</span>
            </NavLink>

            <NavLink to={`${BASE}/contents/event`} className="submenu-item">
              <span
                className={`dot ${
                  isActive("/contents/event") ? "is-selected" : ""
                }`}
              />
              <span className="submenu-text">행사 관리</span>
            </NavLink>

            <NavLink to={`${BASE}/contents/partner`} className="submenu-item">
              <span
                className={`dot ${
                  isActive("/contents/partner") ? "is-selected" : ""
                }`}
              />
              <span className="submenu-text">제휴·협력 관리</span>
            </NavLink>

            <NavLink to={`${BASE}/contents/calendar`} className="submenu-item">
              <span
                className={`dot ${
                  isActive("/contents/calendar") ? "is-selected" : ""
                }`}
              />
              <span className="submenu-text">달력 관리</span>
            </NavLink>
          </div>
        )}

        <div
          className={`sidebar-box clickable ${openMenu.data ? "is-open" : ""}`}
          onClick={() => toggleMenu("data")}
          aria-expanded={openMenu.data}
        >
          <span>자료실 관리</span>
          <span className={`arrow ${openMenu.data ? "is-open" : ""}`} />
        </div>

        {openMenu.data && (
          <div className="submenu">
            <NavLink to={`${BASE}/data/stdcouncil`} className="submenu-item">
              <span
                className={`dot ${
                  isActive("/data/stdcouncil") ? "is-selected" : ""
                }`}
              />
              <span className="submenu-text">총학생회 자료</span>
            </NavLink>

            <NavLink to={`${BASE}/data/central`} className="submenu-item">
              <span
                className={`dot ${
                  isActive("/data/central") ? "is-selected" : ""
                }`}
              />
              <span className="submenu-text">중앙운영위원회 자료</span>
            </NavLink>

            <NavLink to={`${BASE}/data/audit`} className="submenu-item">
              <span
                className={`dot ${
                  isActive("/data/audit") ? "is-selected" : ""
                }`}
              />
              <span className="submenu-text">감사위원회 자료</span>
            </NavLink>

            <NavLink to={`${BASE}/data/etc`} className="submenu-item">
              <span
                className={`dot ${isActive("/data/etc") ? "is-selected" : ""}`}
              />
              <span className="submenu-text">기타 자료</span>
            </NavLink>

            <NavLink to={`${BASE}/data/delegate`} className="submenu-item">
              <span
                className={`dot ${
                  isActive("/data/delegate") ? "is-selected" : ""
                }`}
              />
              <span className="submenu-text">대의원 활동 신청</span>
            </NavLink>
          </div>
        )}

        <div
          className={`sidebar-box clickable ${openMenu.group ? "is-open" : ""}`}
          onClick={() => toggleMenu("group")}
          aria-expanded={openMenu.group}
        >
          <span>조직별 관리</span>
          <span className={`arrow ${openMenu.group ? "is-open" : ""}`} />
        </div>

        {openMenu.group && (
          <div className="submenu">
            <NavLink to={`${BASE}/group/scitech`} className="submenu-item">
              <span
                className={`dot ${
                  isActive("/group/scitech") ? "is-selected" : ""
                }`}
              />
              <span className="submenu-text">과학기술대학 게시판</span>
            </NavLink>

            <NavLink to={`${BASE}/group/global`} className="submenu-item">
              <span
                className={`dot ${
                  isActive("/group/global") ? "is-selected" : ""
                }`}
              />
              <span className="submenu-text">글로벌융합대학 게시판</span>
            </NavLink>

            <NavLink to={`${BASE}/group/future`} className="submenu-item">
              <span
                className={`dot ${
                  isActive("/group/future") ? "is-selected" : ""
                }`}
              />
              <span className="submenu-text">미래인재대학 게시판</span>
            </NavLink>

            <NavLink to={`${BASE}/group/pharm`} className="submenu-item">
              <span
                className={`dot ${
                  isActive("/group/pharm") ? "is-selected" : ""
                }`}
              />
              <span className="submenu-text">약학대학 게시판</span>
            </NavLink>

            <NavLink to={`${BASE}/group/artdesign`} className="submenu-item">
              <span
                className={`dot ${
                  isActive("/group/artdesign") ? "is-selected" : ""
                }`}
              />
              <span className="submenu-text">아트앤디자인대학 게시판</span>
            </NavLink>

            <NavLink to={`${BASE}/group/club`} className="submenu-item">
              <span
                className={`dot ${
                  isActive("/group/club") ? "is-selected" : ""
                }`}
              />
              <span className="submenu-text">동아리연합회 게시판</span>
            </NavLink>
          </div>
        )}

        <div
          className={`sidebar-box clickable ${openMenu.site ? "is-open" : ""}`}
          onClick={() => toggleMenu("site")}
          aria-expanded={openMenu.site}
        >
          <span>사이트 관리</span>
          <span className={`arrow ${openMenu.site ? "is-open" : ""}`} />
        </div>

        {openMenu.site && (
          <div className="submenu">
            <NavLink to={`${BASE}/site/contact`} className="submenu-item">
              <span
                className={`dot ${
                  isActive("/site/contact") ? "is-selected" : ""
                }`}
              />
              <span className="submenu-text">소통 관리</span>
            </NavLink>

            <NavLink to={`${BASE}/site/faq`} className="submenu-item">
              <span
                className={`dot ${isActive("/site/faq") ? "is-selected" : ""}`}
              />
              <span className="submenu-text">FAQ 관리</span>
            </NavLink>

            <NavLink to={`${BASE}/site/banner`} className="submenu-item">
              <span
                className={`dot ${
                  isActive("/site/banner") ? "is-selected" : ""
                }`}
              />
              <span className="submenu-text">메인 배너 관리</span>
            </NavLink>
          </div>
        )}

        <NavLink to={`${BASE}/permission`} className="sidebar-box">
          <span>권한 관리</span>
        </NavLink>

        <NavLink to={`${BASE}/account`} className="sidebar-box">
          <span>내 계정 설정</span>
        </NavLink>
      </nav>
    </aside>
  );
}